// Snapshot history is not a new-message event. Keep an ID-based read baseline
// for this room visit, shared by polling and repeated SignalR snapshots.
export const createChatNotifications = () => {
    const seen = new Set();
    const unread = new Set();
    let initialized = false;
    return {
        reset() { seen.clear(); unread.clear(); initialized = false; },
        initialize(history) {
            if (initialized) return;
            for (const chat of history || []) if (chat.chatId) seen.add(chat.chatId);
            initialized = true;
        },
        observe(history, isOpen, playerId) {
            if (!initialized) return 0;
            for (const chat of history || []) {
                if (!chat.chatId) continue;
                if (!seen.has(chat.chatId) && !isOpen && chat.playerId !== playerId) unread.add(chat.chatId);
                seen.add(chat.chatId);
            }
            if (isOpen) unread.clear();
            return unread.size;
        },
    };
};
